import React, { useState } from "react";
import { Link } from "react-router-dom";
import { requestPasswordReset } from "../api/authClient";

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("idle");
    const [message, setMessage] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("loading");
        setMessage("");

        try {
            const response = await requestPasswordReset(email);
            setStatus("success");
            setMessage(response.message || "If that email exists, a reset link has been sent.");
        } catch (err) {
            setStatus("error");
            setMessage(err.response?.data?.message || "An error occurred. Please try again.");
        }
    };

    if (status === "success") {
        return (
            <div className="min-h-screen flex items-center justify-center px-4">
                <div className="bg-white border border-gray-200 rounded-2xl shadow-sm w-full max-w-md text-center p-8">
                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                        <svg className="w-8 h-8 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                    </div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-3">Check Your Email</h2>
                    <p className="text-gray-500 mb-2">{message}</p>
                    <p className="text-gray-500 text-sm mb-8">The link will expire in 2 hours.</p>
                    <Link to="/login" className="btn-secondary inline-flex">
                        Back to Login
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center px-4">
            <div className="w-full max-w-md">
                <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-8">
                    <div className="text-center mb-8">
                        <Link to="/" className="inline-flex items-center gap-3 mb-6">
                            <div className="w-10 h-10 bg-gray-900 rounded-xl flex items-center justify-center">
                                <span className="text-white font-bold">O</span>
                            </div>
                            <span className="text-xl font-semibold text-gray-900">OmniWorth</span>
                        </Link>
                        <h1 className="text-2xl font-bold text-gray-900">Reset Password</h1>
                        <p className="text-gray-500 mt-2">
                            Enter your email address and we'll send you a link to reset your password.
                        </p>
                    </div>

                    {status === "error" && (
                        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                            <p className="text-sm text-danger-500">{message}</p>
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Email
                            </label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="input"
                                placeholder="you@example.com"
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={status === "loading"}
                            className="btn-primary w-full"
                        >
                            {status === "loading" ? "Sending..." : "Send Reset Link"}
                        </button>
                    </form>

                    <div className="mt-6 text-center">
                        <Link to="/login" className="text-gray-500 hover:text-gray-900 transition-colors">
                            Back to Login
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
